import React from "react"
import { Link as PrismicLink } from "prismic-reactjs"

import { Element, Text, ElementProps } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodyThreeColumnItemType } from "types/__generated__/gatsby-graphql"
import { RichText as PrismicRichText } from "prismic-reactjs"
import RichText from "legacy/components/shared/RichText"
import { mapFontSize } from "src/legacy/utils"

interface OwnProps {
  data: Maybe<PrismicPageDataBodyThreeColumnItemType>
}

export type ColumnTextProps = OwnProps & Pick<ElementProps, "textAlign">

const ColumnText: React.FC<ColumnTextProps> = ({
  data,
  textAlign,
}): React.ReactElement | null => {
  if (!data) return null

  const {
    button_text,
    button_url,
    eyebrow,
    footnote,
    headline,
    headline_font_size,
    wysiwyg,
  } = data
  const headlineFontSize = mapFontSize("header", headline_font_size)

  return (
    <Element textAlign={textAlign}>
      {eyebrow && (
        <Text
          as="p"
          fontSize={["13", "text.captionCaps"]}
          lineHeight={["22px", "normal"]}
          mb={["10", "15"]}
          variant="captionCaps"
        >
          {eyebrow}
        </Text>
      )}
      {headline?.richText?.length > 0 && (
        <Text
          as="h3"
          fontSize={headlineFontSize}
          fontWeight="800"
          lineHeight="1.25"
          mb={["15", "20"]}
          variant="subheader"
        >
          {PrismicRichText.asText(headline?.richText)}
        </Text>
      )}
      <Element>
        {wysiwyg?.richText && <RichText render={wysiwyg?.richText} />}
        {button_text && button_url ? (
          <Link
            mt={["20", "40"]}
            to={PrismicLink.url(button_url)}
            variant="buttonSecondary"
          >
            {button_text}
          </Link>
        ) : null}
        {footnote && (
          <Text
            as="p"
            fontSize={["9", "text.footnote"]}
            lineHeight="1.9"
            variant="body"
          >
            {footnote}
          </Text>
        )}
      </Element>
    </Element>
  )
}

export default ColumnText
